import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import Switch from '../Switch'
import type { SwitchProps } from '../Switch'

const useStyles = makeStyles<Theme>(() => ({
  root: {
    width: '38px !important',
    height: '22px !important'
  },
  switchBase: {
    padding: '1px !important',
    '&.Mui-checked': {
      transform: 'translateX(16px) !important'
    }
  },
  thumb: {
    width: '20px !important',
    height: '20px !important'
  },
  track: {
    width: '38px !important',
    height: '22px !important',
    borderRadius: '11px !important'
  }
}))

const ActiveSwitch = React.forwardRef<HTMLButtonElement, SwitchProps>(function ActiveSwitch(props, ref) {
  const { classes: classesProp, ...rest } = props
  const classes = useStyles()

  return <Switch {...rest} classes={{ ...classes, ...(classesProp || {}) }} ref={ref} />
})

export default ActiveSwitch
